import type { StepsIndicatorAlign, StepsIndicatorVariant } from './types';

export const wrapperBase = 'flex flex-col w-full gap-3';
export const disabledClass = 'opacity-60';

export const labelBase = 'text-xl leading-6';
export const barsWrapperBase = 'flex w-full items-center gap-2';

export const barBase = 'block h-2 w-full rounded-full transition-colors';

export const variantStyles: Record<
  StepsIndicatorVariant,
  { text: string; barActive: string; barInactive: string }
> = {
  light: {
    text: 'text-white',
    barActive: 'bg-white',
    barInactive: 'bg-white/30',
  },
  dark: {
    text: 'text-gray-900',
    barActive: 'bg-gray-900',
    barInactive: 'bg-gray-200',
  },
};

export const alignStyles: Record<StepsIndicatorAlign, string> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};
